import { morphism } from 'morphism'
import { formatDate } from 'tfs.front-end-utils/dates'

import staticData from '../../config/staticData'
import constants from '../../config/constants'

import searchQuerySchema from '../../schemas/searchQuery'

import SearchQueryModel from '../../models/SearchQuery'

import moment from '../../utils/dates/moment'
import setAuthorizationHeader from '../../utils/requests/setAuthorizationHeader'
import {
  userHasCustomTourOperatorCode,
  userCustomTourOperatoreCode,
} from '../../utils/tourOperators'
import { addFlightDetailsToFlights } from '../../utils/searchQuery'
import callAPI from '../../utils/requests/callAPI'

import {
  v1requestSearchResults,
  v1receiveSearchResults,
} from '../../actions/search'
import { V1_SUBMIT_SEARCH_QUERY } from '../../actions/search/v1submitSearchQuery'
import v1throwError from '../../actions/errors/v1throwError'

const urlGenerationFlightRoute = (route, query, store = {}) => {
  const baseURL = staticData.endpoints.allotments.url
  const departureDate = formatDate(
    moment,
    query.departureDate,
    constants.backEndDateFormat,
    constants.fromFlightIdDateFormat
  )
  const params = userHasCustomTourOperatorCode()
    ? `?departureDate=${departureDate}-${departureDate}&route=${route}&tourOperatorCode=${userCustomTourOperatoreCode()}`
    : `?departureDate=${departureDate}-${departureDate}&route=${route}`

  // url fix to be able to call API from localhost
  if (
    !baseURL.endsWith('allotmentspaces') &&
    !baseURL.endsWith('allotmentspaces/')
  ) {
    return `${baseURL}allotmentspaces/${params}`
  }

  return `${baseURL}${params}`
}

const getResults = async (query, store = {}) => {
  try {
    const route = `${query.departureAirport}-${query.arrivalAirport}`

    const headers = new Headers(staticData.endpoints.allotments.headers)
    await setAuthorizationHeader(headers)
    const responseData = await callAPI(
      urlGenerationFlightRoute(route, query, store),
      {
        headers,
      }
    )

    if (responseData.error) return responseData

    return {
      ...query,
      route,
      items: responseData && responseData.length ? responseData : [],
    }
  } catch (error) {
    return error
  }
}

export default store => next => async action => {
  next(action)
  if (action.type !== V1_SUBMIT_SEARCH_QUERY) {
    return
  }

  const dispatch = store.dispatch

  try {
    const {
      departureAirport,
      arrivalAirport,
      departureDate,
      returnDate,
    } = action.data

    let searchQuery = {
      departureAirport,
      arrivalAirport,
      departureDate,
      order: 0,
    }

    dispatch(v1requestSearchResults())

    const departureFlight = await getResults(searchQuery, store)

    if (departureFlight.error) throw departureFlight.error

    const results = []

    const departureFlightWithFlightDetails = await addFlightDetailsToFlights(
      departureFlight
    )

    const formattedDepartureResult = morphism(
      searchQuerySchema,
      departureFlightWithFlightDetails,
      SearchQueryModel
    )
    results.push(formattedDepartureResult)

    if (returnDate) {
      const returnFlight = await getResults(
        {
          ...searchQuery,
          departureDate: returnDate,
          departureAirport: arrivalAirport,
          arrivalAirport: departureAirport,
          order: 1,
        },
        store
      )
      if (returnFlight.error) throw returnFlight.error

      const returnFlightWithFlightDetails = await addFlightDetailsToFlights(
        returnFlight
      )

      const formattedReturnResult = morphism(
        searchQuerySchema,
        returnFlightWithFlightDetails,
        SearchQueryModel
      )
      results.push(formattedReturnResult)
    }

    dispatch(v1receiveSearchResults(results))
  } catch (error) {
    dispatch(v1throwError(error))
  }
}
